import { useTranslation } from 'react-i18next'

import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../../constants/validation'
import {
  useDateLocale,
  useNotification,
  useTimeZone,
} from '../../../../../hooks'
import {
  getMockCalendarDayLoad,
  moveMockCalendarFollowUps,
} from '../../../Calendar.mock'
import {
  formatCalendarDate,
  getCalendarNextDate,
  getIsCalendarFollowUp,
} from '../../../Calendar.utils'
import {
  CalendarRelieveDayModal,
  getCalendarRelieveDayInitialValues,
} from '../../../CalendarRelieveDayModal'

export function useCalendarViewRelieveDay({
  getActionToken,
  setModal,
  onClose,
  onReload,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { handleAddSuccessNotification } = useNotification()

  async function handleSubmitRelieveDay({
    day,
    payload,
    setErrors,
    setSubmitting,
  }) {
    const actionToken = getActionToken()

    // TODO: move the due dates with the requests mass action once the backend
    // returns the day load with it.
    return moveMockCalendarFollowUps({
      date: payload.date,
      ids: payload.ids,
      sourceDate: day,
      timezone,
    })
      .then(() => {
        if (getActionToken() === actionToken) {
          onClose()
        }

        onReload()

        handleAddSuccessNotification({
          title: t('Calendar.RelieveDayDoneToastKey', {
            count: payload.ids.length,
            date: formatCalendarDate({ date: payload.date, locale }),
          }),
        })
      })
      .catch(() => {
        setSubmitting(false)

        setErrors({
          [SERVER_NON_FIELD_ERROR_KEY]: t('Error.CommonApiRequestFailKey'),
        })
      })
  }

  function handleOpenRelieveDayModal({ day, dayLoad, items, nextFreeDay }) {
    setModal(
      <CalendarRelieveDayModal
        day={day}
        dayLoad={dayLoad}
        followUps={items.filter(getIsCalendarFollowUp)}
        initialValues={getCalendarRelieveDayInitialValues({
          nextFreeDay,
          timezone,
        })}
        nextFreeDay={nextFreeDay}
        onClose={onClose}
        onSubmit={handleSubmitRelieveDay}
      />
    )
  }

  async function handleOpenRelieveDay({ day, dayLoad, items }) {
    const actionToken = getActionToken()

    // TODO: read the next free day from the day-load endpoint once the
    // backend serves it.
    return getMockCalendarDayLoad({
      date: getCalendarNextDate(day),
      timezone,
    }).then(
      ({ data }) => {
        if (getActionToken() === actionToken) {
          handleOpenRelieveDayModal({
            day,
            dayLoad,
            items,
            nextFreeDay: { date: data.next_free_date, isFailed: false },
          })
        }
      },
      () => {
        if (getActionToken() === actionToken) {
          handleOpenRelieveDayModal({
            day,
            dayLoad,
            items,
            nextFreeDay: { date: null, isFailed: true },
          })
        }
      }
    )
  }

  return { handleOpenRelieveDay }
}
